import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category?genre=家庭伦理",
    icon: "ri-home-heart-line",
    title: "按题材浏览",
    description: "家庭、社会、青春伦理，五种题材分类",
    meta: "5 类题材",
  },
  {
    to: "/category?year=2024-2025",
    icon: "ri-calendar-line",
    title: "近年新作",
    description: "2024 至 2025 年上线与更新的作品",
    meta: "新增 3 部",
  },
  {
    to: "/category?sort=rating",
    icon: "ri-star-line",
    title: "高分精选",
    description: "评分 8.5 分以上的编辑推荐片单",
    meta: "11 部高分",
  },
  {
    to: "/special",
    icon: "ri-bookmark-3-line",
    title: "专题合集",
    description: "围绕家庭、证词与旧空间的深度专题",
    meta: "3 个专题",
  },
];

export default function QuickLinks() {
  return (
    <section className="border-y border-background-800 bg-background-900">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-px bg-background-800 sm:grid-cols-2 lg:grid-cols-4">
        {entries.map((entry, index) => (
          <Link
            key={entry.title}
            to={entry.to}
            className="group relative bg-background-900 px-5 py-7 transition-colors hover:bg-background-800/80 md:px-7 md:py-8"
          >
            <span className="font-label text-[11px] tracking-[0.24em] text-foreground-500">
              0{index + 1} / {entry.meta}
            </span>
            <span className="mt-4 flex h-10 w-10 items-center justify-center rounded-md border border-background-700 text-accent-400 transition-colors group-hover:border-accent-500 group-hover:bg-accent-500 group-hover:text-background-950">
              <i className={`${entry.icon} text-lg`} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 text-base font-medium text-foreground-950">{entry.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
              {entry.description}
            </p>
            <span className="mt-4 inline-flex items-center gap-2 text-xs text-foreground-500 transition-colors group-hover:text-accent-400">
              进入分类
              <i
                className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                aria-hidden="true"
              ></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}